// eslint-disable-next-line no-restricted-imports
import { useSelector } from "react-redux";

interface ChatChannel {
  unreadMessageCount?: number;
}

interface ChatState {
  chat: {
    channels: ChatChannel[];
  };
}

export function useUnreadChannelCount(): number {
  const { channels } = useSelector((state: ChatState) => state.chat);

  let unreadChannelCount = 0;
  for (const channel of channels) {
    if (channel.unreadMessageCount) {
      unreadChannelCount += channel.unreadMessageCount;
    }
  }

  return unreadChannelCount;
}
